<!-- Join Organisation Request Table Content -->
<app-table
          [columns]="joinOrgColumns"
          [data]="joinOrgData"
          [scrollHeight]="'400px'"
          [loading]="loading"
          [pagination]="joinOrgPagination"
          [emptyMessage]="joinOrgEmptyMessage"
          [striped]="true"
          [bordered]="true"
          [hoverable]="true"
          (pageChange)="onJoinOrgPageChange($event)"
          (pageSizeChange)="onJoinOrgPageSizeChange($event)"
        >
          <!-- Custom Status Column with Chip Design -->
          <ng-template #joinOrgStatusCell let-row>
            <span class="status-chip" 
                  [class.status-chip--pending]="isStatusPending(row.status)" 
                  [class.status-chip--approved]="row.status?.toLowerCase() === 'granted' || row.status?.toLowerCase() === 'approved'"
                  [class.status-chip--rejected]="row.status?.toLowerCase() === 'rejected'"
                  [class.status-chip--withdrawn]="isStatusWithdrawn(row.status)">
              {{ row.status || 'N/A' }}
            </span>
          </ng-template>

          <!-- Custom Action Column for Join Requests -->
          <ng-template #joinOrgActionCell let-row>
            <div class="action-cell-wrapper">
              <button 
                class="action-btn" 
                (click)="toggleActionDropdown($event, row)"
                [class.active]="isDropdownOpen(row)"
                type="button"
              >
                <span>Action</span>
              </button>
              
              <!-- Dropdown Menu -->
              <div 
                class="action-dropdown-menu" 
                *ngIf="isDropdownOpen(row)" 
                [attr.data-dropdown-id]="getRowId(row)"
                (click)="$event.stopPropagation()"
              >
                <ul class="dropdown-list">
                  <li class="dropdown-item">
                    <button class="dropdown-link" (click)="handleJoinOrgAction('view', row, $event)">
                      View
                    </button>
                  </li>
                  <li class="dropdown-item">
                    <button 
                      class="dropdown-link" 
                      (click)="handleJoinOrgAction('approve', row, $event)"
                      [disabled]="isStatusFinal(row.status)"
                    >
                      Approve
                    </button>
                  </li>
                  <li class="dropdown-item">
                    <button 
                      class="dropdown-link dropdown-link--danger" 
                      (click)="handleJoinOrgAction('reject', row, $event)"
                      [disabled]="isStatusFinal(row.status)"
                    >
                      Reject
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </ng-template>
</app-table>

<!-- View Request Details Modal -->
<app-modal
  [(visible)]="showViewModal"
  header="Join Request Details"
  [width]="'700px'"
  [showFooter]="false"
  (visibleChange)="showViewModal = $event"
>
  <div class="view-request-modal-content" *ngIf="selectedRequestData">
    <!-- Leaf Pattern Decoration -->
    <div class="view-modal-leaf-pattern">
      <img src="/assets-leaf.png" alt="" class="view-modal-leaf-image" />
    </div>
    
    <div class="request-details">
      <div class="detail-row">
        <div class="detail-label">User Name:</div>
        <div class="detail-value">{{ selectedRequestData.user_name || selectedRequestData.userName || 'N/A' }}</div>
      </div>
      <div class="detail-row">
        <div class="detail-label">Employee ID:</div>
        <div class="detail-value">{{ selectedRequestData.emp_id || selectedRequestData.employeeId || 'N/A' }}</div>
      </div>
      <div class="detail-row">
        <div class="detail-label">Job Title:</div>
        <div class="detail-value">{{ selectedRequestData.job_title || selectedRequestData.jobTitle || 'N/A' }}</div>
      </div>
      <div class="detail-row">
        <div class="detail-label">Email:</div>
        <div class="detail-value">{{ selectedRequestData.official_email || selectedRequestData.email || 'N/A' }}</div>
      </div>
      <div class="detail-row">
        <div class="detail-label">Status:</div>
        <div class="detail-value">
          <span class="status-badge" [class.status-pending]="isStatusPending(selectedRequestData.status)" 
                [class.status-approved]="selectedRequestData.status?.toLowerCase() === 'granted' || selectedRequestData.status?.toLowerCase() === 'approved'"
                [class.status-rejected]="selectedRequestData.status?.toLowerCase() === 'rejected'"
                [class.status-withdrawn]="isStatusWithdrawn(selectedRequestData.status)">
            {{ selectedRequestData.status || 'N/A' }}
          </span>
        </div>
      </div>
      <div class="detail-row">
        <div class="detail-label">Requested At:</div>
        <div class="detail-value">{{ formatDate(selectedRequestData.requested_at || selectedRequestData.requestedDate) || 'N/A' }}</div>
      </div>
      <div class="detail-row" *ngIf="getHighestRole(selectedRequestData.roles)">
        <div class="detail-label">Role:</div>
        <div class="detail-value">
          <span class="role-badge">{{ getHighestRole(selectedRequestData.roles) }}</span>
        </div>
      </div>
      <div class="detail-row">
        <div class="detail-label">Account Enabled:</div>
        <div class="detail-value">
          <span class="account-status" [class.enabled]="selectedRequestData.account_enabled" 
                [class.disabled]="!selectedRequestData.account_enabled">
            {{ selectedRequestData.account_enabled ? 'Yes' : 'No' }}
          </span>
        </div>
      </div>
    </div>
  </div>
</app-modal>
